export default "__VITE_ASSET__BJMV30d2__"